// extracted by mini-css-extract-plugin
export var colorSquare = "_t5-0";
export var danger = "_t5-5";
export var lightPink = "_t5-8";
export var neutralBlue = "_t5-7";
export var neutralYellow = "_t5-6";
export var normal = "_t5-1";
export var primary = "_t5-2";
export var primaryLight = "_t5-3";
export var solidBlack = "_t5-g";
export var solidGreen = "_t5-b";
export var solidLightBlue = "_t5-d";
export var solidNavy = "_t5-c";
export var solidOrange = "_t5-f";
export var solidPink = "_t5-e";
export var solidRed = "_t5-9";
export var solidYellow = "_t5-a";
export var success = "_t5-4";